import { IBaseResponse, fetchWrapper } from './apiBase';
import { IPagination, ICommit, IRepository } from '@/types';
import { IRepositoryCompareEntry } from '@/lib/repositoryCompareApi';
import { BASE_API_URL } from '@/config/environment';

export interface IDirectoryDiffTreeResponse extends IBaseResponse {
  dirs: TDiffDirectory[];
}

type TDirItem = {
  name: string;
  status: 'added' | 'removed' | 'modified';
};

type TDiffDirectory = {
  can_display: boolean;
  children: TDirItem[];
  name: string;
  num_subdirs: number;
};

export interface IDirectoryDiffResponse extends IBaseResponse, IPagination {
  compare: {
    base_commit: ICommit;
    head_commit: ICommit;
    self: IRepositoryCompareEntry;
    counts: {
      added: number;
      removed: number;
      modified: number;
    };
    entries: IRepositoryCompareEntry[];
  };
}

export const fetchDirectoryDiffTree = async ({
  repository,
  baseRef,
  headRef,
  token,
}: {
  repository: IRepository;
  baseRef: string;
  headRef: string;
  token?: string;
}): Promise<IDirectoryDiffTreeResponse> => {
  const { namespace, name: repositoryName, access_level } = repository;
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/compare/dir_tree/${baseRef}..${headRef}`; // /${filePath}`;

  return await fetchWrapper({
    resourceName: 'dirTreeDiff',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, access_level },
  });
};

export const fetchDirectoryDiff = async ({
  repository,
  baseRef,
  headRef,
  filePath,
  token,
}: {
  repository: IRepository;
  baseRef: string;
  headRef: string;
  filePath: string;
  token?: string;
}): Promise<IDirectoryDiffResponse> => {
  const { namespace, name: repositoryName, access_level } = repository;
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/compare/entries/${baseRef}..${headRef}/dir/${filePath}`;

  return await fetchWrapper({
    resourceName: 'dirTreeDiff',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, access_level },
  });
};
